<template>
  <div>
    <a-row class="message-outer">
      <a-col v-if="type === 'system'" :span="18" class="system-message">
        <p>{{ content }}</p>
      </a-col>
      <a-col v-else :class="'message ' + side + ' ' + type" :span="18">
        <div v-if="mentionedMessage">
          <p class="author">W odpowiedzi na wiadomość...</p>
          <div class="mentioned-message">
            <vue-markdown
                :anchorAttributes="{ target: '_blank', rel: 'nofollow' }"
                :linkify="true"
                :xhtml-out="true"
                class="markdown-field"
            >
              {{ mentionedMessage.content.trim() }}
            </vue-markdown>
          </div>
        </div>

        <div v-if="type === 'media'">
          <img
              :src="mediaUrl"
              class="media-message"
              @click="$refs.zoomImage.show()"
          />
          <ImageZoom ref="zoomImage" :image="mediaUrl"/>
        </div>

        <div v-if="content">
          <vue-markdown
              :anchorAttributes="{ target: '_blank', rel: 'nofollow' }"
              :linkify="true"
              :xhtml-out="true"
              class="markdown-field"
          >
            {{ content.trim() }}
          </vue-markdown>
        </div>
        <div v-if="!content && !mediaUrl">Pisze...</div>
      </a-col>
      <div
          v-if="type !== 'system'"
          :style="{ textAlign: side === 'left' ? 'left' : 'right' }"
      >
        <a-button
            class="mention-button"
            icon="link"
            shape="circle"
            type="link"
            @click="mentionComment"
        />
        <a-popover :placement="side == 'left' ? 'right' : 'left'">
          <template slot="content">
            <span>{{ date | moment("H:mm:ss &bull; DD.MM.yyyy r.") }}</span>
          </template>
          <a-button
              class="mention-button"
              icon="info-circle"
              shape="circle"
              type="link"
          />
        </a-popover>
      </div>
    </a-row>
    <a-row v-if="date && type !== 'system'">
      <p :class="'datetime ' + side">
        {{ momentDate | moment("from", "now") }}
      </p>
    </a-row>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown";
import ImageZoom from "@/components/utils/ImageZoom";

export default {
  name: "Message",
  props: {
    messageId: Number,
    content: String,
    mediaUrl: String,
    author: String,
    side: String,
    date: String,
    type: String,
    mentionedMessage: Object,
  },
  components: {
    VueMarkdown,
    ImageZoom,
  },
  data() {
    return {
      momentDate: new Date(),
    };
  },
  methods: {
    postRenderMessage: function (event) {
      console.log(event);
    },
    mentionComment: function () {
      this.$emit("mention", this.messageId);
    },
  },
  mounted() {
    if (this.date) {
      this.momentDate = new Date(this.date);
      setInterval(() => {
        this.momentDate = new Date(this.date);
      }, 1000);
    }
  },
};
</script>

<style scoped>
.author {
  font-size: 10px;
  font-weight: 600;
}

.datetime {
  font-size: 10px;
  color: rgba(0, 0, 0, 0.45);
  padding: 0px 20px;
}

.datetime.right {
  text-align: right;
}

.message {
  width: auto;
  max-width: 60%;
  padding: 12px 16px;
  margin-bottom: 6px;
  background-color: rgba(0, 0, 0, 0.075);
  border-radius: 12px 12px 12px 4px;
  word-wrap: break-word;
}

.message.right {
  float: right;
  border-radius: 12px 12px 4px 12px;
  background-color: rgb(43, 140, 250);
  color: rgb(255, 255, 255);
}

.message.media {
  padding: 0px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.message.media .media-message {
  max-height: 30vh;
  border-radius: 12px 12px 12px 4px;
  user-select: none;
  cursor: zoom-in;
}

.message.right .media-message {
  border-radius: 12px 12px 4px 12px;
}

.system-message {
  margin: 20px 20px;
  width: 100%;
  text-align: center;
  font-size: 12px;
}

.system-message p:before {
  position: absolute;
  top: 0px;
  display: block;
  background-color: red;
  width: 100%;
  height: 100px;
  z-index: 9;
}

.mentioned-message {
  padding: 6px 10px;
  border-radius: 6px;
  margin-bottom: 6px;
  background-color: rgba(255, 255, 255, 0.2);
}

.message.left .mentioned-message {
  background-color: rgba(0, 0, 0, 0.1);
}

.mention-button {
  opacity: 0;
}

.message-outer:hover .mention-button {
  opacity: 1;
}
</style>

<style>
.markdown-field p:last-child {
  margin-bottom: 0em !important;
}

.message.right a {
  color: rgb(203, 227, 255);
  text-decoration: underline;
}
</style>